const CreditPlanTypes = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  BACKUP: "BACKUP"
};

export default CreditPlanTypes;
